import { v4 as uuidv4 } from 'uuid';

export const tabSessionUUID = uuidv4();

export const defaultAvatarPath = `/default_avatar.png`;

export const rtkCacheTTL = {
  normal: 30, // basic usage
  long: 60, // for resource that won't mutate frequently, for example common api
};
